import { DateString } from '~/types/CommonTypes';
import { Validator } from './Validator.abstract';

export enum TransactionDirectionEnum {
  Incoming = 1,
  Outgoing = 2,
}

export enum TransactionTypeEnum {
  CREDIT = 1,
  DEBIT = 2,
}

export enum TransactionTypeDtoEnum {
  'Crédito' = 1,
  'Débito' = 2,
}

export class Transaction extends Validator {
  _id: string;
  transactionDateTime: Date | null;
  amount: string;
  type: TransactionTypeEnum | null;
  sign: string;
  source: string;
  transactionDirection?: TransactionDirectionEnum | null;
  description: string;
  transactionIdentifier: string;
  username: string;

  constructor(data: Partial<Transaction>) {
    super();
    const validate = this.validate();

    this._id = validate.string(data._id, '_id');
    this.transactionDateTime = validate.date(
      data.transactionDateTime,
      'transactionDateTime',
    );
    this.amount = validate.currency(data.amount, 'amount');
    this.type = this.validateTransactionType(data.type);
    this.sign = validate.string(data.sign, 'sign');
    this.source = validate.string(data.source, 'source');
    this.transactionDirection = this.validateTransactionDirection(
      data.transactionDirection,
    );
    this.description = validate.string(data.description, 'description');
    this.transactionIdentifier = validate.string(
      data.transactionIdentifier,
      'transactionIdentifier',
    );
    this.username = validate.string(data.username, 'username');
  }

  private validateTransactionType(value: unknown): TransactionTypeEnum | null {
    if (typeof value !== 'number') {
      console.error(`Invalid transactionType type: ${typeof value}`);
      console.warn(`transactionType was set to null.`);

      return null;
    }
    if (value !== 1 && value !== 2) {
      console.error(`Invalid transactionType value: ${value}`);
      console.warn(`transactionType was set to null.`);

      return null;
    }

    return value;
  }

  private validateTransactionDirection(transactionDirection: unknown): 1 | 2 | null {
    if (typeof transactionDirection !== 'number') {
      console.error(`Invalid transactionDirection type: ${typeof transactionDirection}`);
      console.warn(`transactionDirection was set to null.`);

      return null;
    }
    if (transactionDirection !== 1 && transactionDirection !== 2) {
      console.error(`Invalid transactionDirection value: ${transactionDirection}`);
      console.warn(`transactionDirection was set to null.`);

      return null;
    }

    return transactionDirection;
  }
}

export class TransactionDto {
  id: number | string;
  transactionDateTime: DateString;
  value: number;
  type: TransactionTypeDtoEnum;
  sign: string;
  transactionDirection: TransactionDirectionEnum;
  source: string;
  description: string;
  transactionIdentifier: string;
  username: string;

  constructor(data: TransactionDto) {
    this.id = data.id;
    this.transactionDateTime = data.transactionDateTime;
    this.value = data.value;
    this.type = data.type;
    this.sign = data.sign;
    this.source = data.source;
    this.description = data.description;
    this.transactionDirection = data.transactionDirection;
    this.transactionIdentifier = data.transactionIdentifier;
    this.username = data.username;
  }
}

export class TransactionListItem extends Validator {
  _id: string;
  transactionDateTime: Date | null;
  amount: string;
  description: string;

  constructor(data: Partial<Transaction | TransactionListItem>) {
    super();
    const validate = this.validate();

    this._id = validate.string(data._id, '_id');
    this.transactionDateTime = validate.date(
      data.transactionDateTime,
      'transactionDateTime',
    );
    this.amount = validate.currency(data.amount, 'amount');
    this.description = validate.string(data.description, 'description');
  }
}

export class TransactionListFiltersDto {
  StartDate: string = new Date(
    new Date(new Date().setDate(new Date(Date.now()).getDate() - 5)).setHours(0, 0, 0, 0),
  ).toISOString();
  EndDate: string = new Date(new Date(Date.now()).setHours(0, 0, 0, 0)).toISOString();
  Type?: string;
  Description?: string;
  Source?: string;
  TransactionIdentifier?: string;
  Page: number = 1;
  PageSize: number = 20;
  Sort: 'asc' | 'desc' = 'asc';
}

export class TransactionListFilters {
  date: Date[] = [
    new Date(new Date().setDate(new Date(Date.now()).getDate() - 5)),
    new Date(Date.now()),
  ];
  description?: string;
  transactionDirection?: TransactionDirectionEnum;
  transactionIdentifier?: string;
  source?: string;
  type?: string;
  page: number = 1;
  pageSize: number = 20;
  sort: 'asc' | 'desc' = 'asc';

  constructor(data?: TransactionListFilters) {
    Object.assign(this, data);
  }
}
